import { generateActions, generateSelectors, generateTypes } from "../util";

export const key = "samples";

// get sample models
export const READ_SAMPLES = generateTypes(key, "read");
export const [readSamples, readSamplesSuccess, readSamplesError, readSamplesBusy] = generateActions(READ_SAMPLES);
export const [selectSamples, selectSamplesError, selectSamplesBusy, , selectSamplesRequest] =
  generateSelectors(READ_SAMPLES);
